module.exports = __webpack_public_path__ + "static/media/onoiwa-product-cover.e1e0304e.png";